export enum Font {
    Poppins = "'Poppins', sans-serif",
    SpaceGrotesk = "'Space GroteskVariable', sans-serif",

    Inter = "'Inter Variable', sans-serif",
    PublicSans = "'Public Sans Variable', 'Helvetica Neue', system-ui, sans-serif",
}
